import React from 'react';
import { Section } from '../ui/Section';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Identify',
    desc: 'Use the National Scan to find "Notice of Sale" properties in your target zip code.'
  }, {
    num: '02',
    title: 'Analyze',
    desc: 'Run the "Blind Valuation" and "Title-First" rules to set your Walk-Away Number.'
  }, {
    num: '03',
    title: 'Execute',
    desc: 'Deploy the Auction-to-Refi Bridge to win the property and secure your long-term 3.5% financing.'
  }];
  return <Section theme="black" className="border-b border-gold-hairline" data-id="element-63">
      <div className="mb-6 flex flex-col items-center" data-id="element-64">
        <div className="flex items-center gap-4 mb-4" data-id="element-65">
          <div className="h-[1px] w-8 bg-gold/30" data-id="element-66"></div>
          <span className="text-gold text-xs font-semibold tracking-[0.2em] uppercase" data-id="element-67">
            How It Works
          </span>
          <div className="h-[1px] w-8 bg-gold/30" data-id="element-68"></div>
        </div>
      </div>

      <h2 className="text-3xl md:text-4xl font-serif font-medium mb-20 text-center text-bone" data-id="element-69">
        Three steps to your first auction win.
      </h2>

      <div className="grid md:grid-cols-3 gap-12 relative" data-id="element-70">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-16 right-16 h-[1px] bg-gold-hairline z-0" data-id="element-71"></div>

        {steps.map((step, idx) => <div key={idx} className="relative z-10 flex flex-col items-center text-center md:items-start md:text-left" data-id="element-72">
            <div className="w-24 h-24 bg-onyx border border-gold-hairline p-1 rounded-full mb-8 shadow-editorial-dark" data-id="element-73">
              <div className="w-full h-full border border-gold/40 rounded-full flex items-center justify-center bg-black" data-id="element-74">
                <span className="text-3xl font-serif font-medium italic text-gold" data-id="element-75">
                  {step.num}
                </span>
              </div>
            </div>
            <h3 className="text-2xl font-serif font-medium mb-4 text-bone" data-id="element-76">
              {step.title}
            </h3>
            <p className="text-bone-muted text-lg leading-relaxed" data-id="element-77">
              {step.desc}
            </p>
          </div>)}
      </div>
    </Section>;
}